import { configureStore } from '@reduxjs/toolkit';
import productGridReducer from './slices/productGridSlice';

const store = configureStore({
  reducer: {
    productGrid: productGridReducer,
  },
});

export default store;
